import { combineReducers } from 'redux';
import fetchFeedReducer from './fetchFeedReducer';

export default combineReducers({
  fetchFeedReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js